import { useSyncExternalStore } from 'react';

/* ------------------------------------------------------------------ *
 * Layout decisions that CSS cannot make.
 *
 * The manifest panel and the sheet are the same component presented
 * two ways; only one may be mounted at a time, so the choice has to
 * happen in JS. Everything else responsive stays in CSS, where it
 * belongs — this hook exists for the handful of cases where two
 * different DOM trees are genuinely required.
 * ------------------------------------------------------------------ */

const subscribe = (query: string) => (onChange: () => void) => {
  const mql = window.matchMedia(query);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
};

export const useMediaQuery = (query: string): boolean =>
  useSyncExternalStore(
    subscribe(query),
    () => window.matchMedia(query).matches,
    () => false, // SSR / first paint: assume narrow, then correct.
  );

/** Matches the breakpoint at which the manifest pane stops fitting. */
export const useHasManifestSpace = (): boolean => useMediaQuery('(min-width: 1101px)');
